import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
import ReactPlayer from "react-player";

import PlaceholderIMG from "../../sharedComponents/placeholderImage";
import Image from "../../assets/images/referafriend.jpg";

export default () => {
	const componentRef = useRef(null);

	return (
		<section className="page page-refer-a-friend">
			<div className="container">
				<div className="row">
					<div className="col-8">
						<div className="image-holder" ref={componentRef}>
							<PlaceholderIMG src={Image} />
						</div>
					</div>
					<div className="col-4">
						<h3>Share your experience…</h3>
						<p>
							Share your weight loss experience with your friends and family by inviting them to begin their own
							journey with Medi-Weightloss<sup>&reg;</sup>.
						</p>
						<ReactToPrint
							trigger={() => (
								<button className="btn btn-primary-dark print-hidden">
									<i className="icon icon-print" /> Print your referral card now!
								</button>
							)}
							content={() => componentRef.current}
						/>
						<div className="video-container">
							<ReactPlayer
								url={`https://www.youtube.com/watch?v=XDHIDIjdBM0`}
								width="100%"
								height="100%"
								controls
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
